import React from "react";


const StageSelect = ({ onSelectStage, selectedStageId }) => {
  
    const getStagePath = (stage_id) => {
      return `/stages/STAGE_${stage_id}.webp`;
    }
  
    return (
      <div className="col-span-1">
        <label htmlFor="fav_stage" className="block pb-4">
          Favorite Stage
        </label>
        <div className="flex justify-center space-x-1 lg:space-x-2">
          {Array.from({ length: 7 }, (_, stage_id) => (
            <div
              key={stage_id}
              className={`cursor-pointer lg:p-1 border border-gray-700 rounded-lg duration-200 ease-in-out ${
                selectedStageId === stage_id
                  ? "border-pink-100 scale-105 hover:scale-105"
                  : "border-transparent scale-100 hover:scale-105"
              }`}
              onClick={() => onSelectStage(stage_id)}
            >
              <img
                src={getStagePath(stage_id)}
                alt=""
                className="transform transition-transform rounded-lg"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    );
  };
  
  export default StageSelect;